export const APP_CONFIG = {

  app: 'schoolarena.de',
  appName: 'schoolarena',
  user: 'Zied Mayel',
  email: 'z.mayel@hotmail.com',
  twitter: '',
  avatar: 'avatar-admin.png',
  version: '4.0.0',
  bs4v: '4.3',
  logo: 'logo_s_v2_h_70.png',
  logoM: 'logo.png',
  // tslint:disable-next-line:max-line-length
  copyright: '2020 © schoolarena.de by&nbsp;<a href="https://www.schoolarena.de" class="text-primary fw-500" title="schoolarena.de" target="_blank">schoolarena.de</a>',
  // tslint:disable-next-line:max-line-length
  // copyrightInverse: '2019 © SmartAdmin by&nbsp;<a href="https://www.gotbootstrap.com" class="text-white opacity-40 fw-500" title="gotbootstrap.com" target="_blank">gotbootstrap.com</a>'
};
